export default "__VITE_ASSET__025afb8f__"